import { BKJListItem, BKJSelect, BKJTextArea } from '@awais4123/fillify-design-library';
import { AutoMargin } from 'components/AutoMargin';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { useShiftModalDataContext } from 'components/ShiftModal/ShiftModalProvider.data.context';
import { releaseReasons } from 'components/ShiftModal/src/views/ReleaseShiftView/ReleaseShiftView.constant';
import {
  useReleaseShiftViewContext,
  ReleaseShiftViewProvider,
} from 'components/ShiftModal/src/views/ReleaseShiftView/ReleaseShiftView.context';
import {
  FormGroup,
  FormLabel,
  InnerWrapper,
  ReleaseContent,
  ReleaseShiftTitle,
  ReleaseShiftViewWrapper,
  ConfirmationButton,
} from 'components/ShiftModal/src/views/ReleaseShiftView/ReleaseShiftView.styled';
import { ReleaseShiftViewWarning } from 'components/ShiftModal/src/views/ReleaseShiftView/ReleaseShiftViewWarning';
import { useTranslation } from 'hooks/useTranslation';
import { FC, Fragment, MouseEventHandler } from 'react';
import { OrderStatusEnum } from 'types/graphql';
import { getTranslatedResponse } from 'utils/getTranslatedResponse';

export const ReleaseShiftViewComponent: FC = () => {
  const { t, i18n } = useTranslation();

  const { values, onChange, isDisabled, onSubmit, isSubmitting } = useReleaseShiftViewContext();
  const {
    data: {
      fetchOrder: { status },
    },
  } = useShiftModalDataContext();

  const isShiftAssignedOrAcceptedOrSwapped = [
    OrderStatusEnum.assigned,
    OrderStatusEnum.accepted,
    OrderStatusEnum.swapped,
  ].includes(status.value);

  const transformedReleaseReasons = releaseReasons.filter((reason) => {
    if (isShiftAssignedOrAcceptedOrSwapped)
      return reason.value != 'communicated_absence' && reason.value != 'no_show';
    return releaseReasons;
  });

  return (
    <Fragment>
      <ReleaseShiftViewWrapper flexDirection="column">
        <ReleaseShiftTitle>{t('shift_modal:RELEASE_TEAM_MEMBER_CONFIRMATION')}</ReleaseShiftTitle>
        <InnerWrapper>
          <ReleaseShiftViewWarning />
          <FormGroup>
            <FormLabel>{t('shift_modal:REASON_FOR_RELEASE')}:*</FormLabel>
            <BKJSelect
              options={transformedReleaseReasons}
              type="Single"
              width="100%"
              variant="GreyOutlined"
              placeholder={t('shift_modal:SELECT_A_REASON')}
              value={[values.reason_category]}
              name="reason_category"
              required
              onChange={onChange}
              renderOptions={({ options, selected, onChange }) => {
                return (
                  <Fragment>
                    {transformedReleaseReasons.map(({ key, label, value }) => {
                      const translatedLabel = getTranslatedResponse(label, 'status', i18n, t);
                      return (
                        <BKJListItem
                          name="reason_category"
                          selected={selected}
                          key={key}
                          label={translatedLabel}
                          value={value}
                          onChange={onChange}
                        />
                      );
                    })}
                  </Fragment>
                );
              }}
            />
          </FormGroup>
          {values.reason_category === 'other' && (
            <FormGroup>
              <FormLabel>{t('shift_modal:PLEASE_SPECIFY_REASON')}:*</FormLabel>
              <BKJTextArea
                name="reason_message"
                placeholder={t('shift_modal:REASON_VISIBLE_TO_FACILITY_AND_TEAM_MEMBER')}
                value={values.reason_message}
                onChange={onChange}
                maxLength={200}
              />
            </FormGroup>
          )}

          <ReleaseContent>{t('shift_modal:TEAM_MEMBER_WILL_BE_NOTIFIED')}</ReleaseContent>
        </InnerWrapper>
      </ReleaseShiftViewWrapper>
      <BKJSideModalFooter>
        <AutoMargin />
        <ConfirmationButton
          width="180px"
          variant="RedSolid"
          disabled={isDisabled}
          isLoading={isSubmitting}
          onClick={onSubmit as unknown as MouseEventHandler<HTMLButtonElement>}
        >
          {t('shift_modal:RELEASE')}
        </ConfirmationButton>
      </BKJSideModalFooter>
    </Fragment>
  );
};

export const ReleaseShiftView: FC = () => {
  return (
    <ReleaseShiftViewProvider>
      <ReleaseShiftViewComponent />
    </ReleaseShiftViewProvider>
  );
};
